import React, { useState } from "react"

import { Slider } from "components/anti/slider/slider"
import { Card } from "components/anti/card/card"
import { useScrollAnim } from "src/components/hooks/hooks"


export const ProjectDetailsVirtualTour = ({ data }) => {
    const [trigger, anim] = useScrollAnim()

    const [sliderIndex, setSliderIndex] = useState(0)

    return (
        <>
            {data.type && (
                <section className="pt-main py-md-6 sc-project-nearby" ref={trigger}>
                    <div className="container">
                        <h2 className={`${anim(1)}`}>{data?.title}</h2>
                        <Slider
                            visibleInitial={true}
                            visibleXxlDown={true}
                            visibleXlDown={true}
                            visibleLgDown={true}
                            visibleMdDown={true}
                            dotsInitial={false}
                            dotsXxlDown={false}
                            dotsXlDown={false}
                            dotsLgDown={false}
                            dotsMdDown={false}
                            showInitial={3.25}
                            showXxlDown={3.25}
                            showXlDown={3.25}
                            showLgDown={2.5}
                            showMdDown={1}
                            arrowsInitial={true}
                            arrowsXxlDown={true}
                            arrowsXlDown={true}
                            arrowsLgDown={true}
                            arrowsMdDown={true}
                            beforeChange={val => setSliderIndex(val)}
                            className="mt-4 project-nearby d-none d-sm-block"
                        >
                            {data?.type?.map((project, i) => {
                                const cover = project?.image?.sourceUrl
                                const title = project?.title
                                const label = project?.label
                                const altText = project?.image?.altText
                                return (
                                    <Card
                                        variant="overlay"
                                        img={cover}
                                        imgRatio="r-4-3"
                                        imgAlt={altText ? altText : "Image"}
                                        className={`text-white ${anim(2 + i)}`}
                                        key={i}
                                        link={project?.url}
                                    >
                                        <p className="mb-0">{label}</p>
                                        <h3>{title}</h3>
                                    </Card>
                                )
                            })}
                        </Slider>
                    </div>
                    <Slider
                        noGutter
                        visibleSmDown={false}
                        dotsSmDown={false}
                        showSmDown={1}
                        arrowsSmDown={true}
                        beforeChange={val => setSliderIndex(val)}
                        className="mt-4 project-nearby d-block d-sm-none"
                    >
                        {data?.type?.map((project, i) => {
                            const cover = project?.image?.sourceUrl
                            const title = project?.title
                            const label = project?.label
                            return (
                                <Card
                                    variant="overlay"
                                    img={cover}
                                    imgRatio="r-4-3"
                                    className={`text-white ${anim(2 + i)}`}
                                    key={i}
                                    link={project.url}
                                >
                                    <p className="mb-0">{label}</p>
                                    <h3>{title}</h3>
                                </Card>
                            )
                        })}
                    </Slider>
                    <div className={`progress-wrapper d-block d-md-none ${anim(4)}`}>
                        <div className="bar-wrapper">
                            <div
                                className="progress-bar"
                                style={{
                                    width: `${((sliderIndex + 1) / data?.type?.length) * 100}%`,
                                }}
                            />
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}